import { Component, Input, OnInit } from '@angular/core';
import { AssetModel } from '~contentful/models/core/asset.model';

@Component({
  selector: 'app-asset',
  templateUrl: './asset.component.html',
  styleUrls: ['./asset.component.scss']
})
export class AssetComponent implements OnInit {

  @Input()
  public readonly model: AssetModel;

  public get isImage() {
    return this.model.file.contentType.startsWith('image');
  }

  constructor() { }

  ngOnInit() {
  }

}
